import { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, EffectFade, Lazy } from "swiper";
import SlideButton from "./Slide-Button";
import { Button, Modal } from "react-bootstrap";
import axios from "axios";

import "swiper/css";
import "swiper/css/lazy";
import "swiper/css/pagination";
import "swiper/css/effect-fade";
import "swiper/css/autoplay";
import { Arrowrightw } from "../../icons";
import Timer from "./Timer";
import { SPEEDSIZE_PREFIX } from "../../App";

const CTA_DEFAULT_TEXT = "Regístrate";
const CTA_DEFAULT_URL =
  "https://www.codere.mx/registro-deportes?clientType=sportsbook";

function isLiveOnTv() {
  const curDate = new Date().toISOString();
  const zuluDate = new Date(curDate);

  // Check if it's either Wednesday or Friday
  if (
    zuluDate.getUTCDay() === 3 ||
    zuluDate.getUTCDay() === 4 ||
    zuluDate.getUTCDay() === 5
  ) {
    const hour = zuluDate.getUTCHours();
    if (hour === 7) {
      // Check minutes if between 0 to 59
      const minutes = zuluDate.getUTCMinutes();
      if (minutes >= 0 && minutes <= 59) {
        return true;
      }
    }
  }
  return false;
}

function MySwiper({ device }) {
  const [swiper, setSwiper] = useState(null);
  // const [currentTycType, setCurrentTycType] = useState(null);
  // const [disclamerDataName, setDisclamerDataName] = useState({});
  // const [currentBannerName, setCurrentBannerName] = useState("");

  const [tycObject, setTycObject] = useState({
    type: "No Tyc",
    refTo: "",
    title: "",
  });

  const [disclaimer, setDisclaimer] = useState("");
  const [showTycModal, setShowTycModal] = useState(false);
  // const [showTimer, setShowTimer] = useState(false);

  const [ctaText, setCtaText] = useState(CTA_DEFAULT_TEXT);
  const [ctaLink, setCtaLink] = useState(CTA_DEFAULT_URL);

  const [imgs, setImgs] = useState([]);
  const [liveBanners, setLiveBanners] = useState([]);

  const indexHandler = (swiper) => {
    setSwiper(swiper);
    try {
      // setShowTimer(liveBanners[swiper.realIndex].hasTimer && !isLiveOnTv());
      setCtaText(liveBanners[swiper.realIndex].ctaText);
      setCtaLink(liveBanners[swiper.realIndex].ctaURL);
      setTycObject(liveBanners[swiper.realIndex].tycObject);
      setDisclaimer(liveBanners[swiper.realIndex].disclaimer || "");
    } catch (error) {}
  };

  useEffect(() => {
    const PORT = `${
      process.env.REACT_APP_SERVER || "http://localhost:5001"
    }/prd/mexico/fetch-banners`;

    axios
      .get(PORT, {
        headers: JSON.parse(process.env.REACT_APP_SER_HEADER),
      })
      .then((res) => {
        let x = res.data.filter(BannerFilter);

        setImgs([...x]);

        setLiveBanners(
          x.reduce((acc, obj) => {
            const tempBanner = {
              ...obj,
              image: obj.image.replace("xxx", device ? "mobile" : "desktop"),
            };
            acc.push(tempBanner);
            return acc;
          }, [])
        );
      })
      .catch((err) => console.log(err));
  }, []);

  useEffect(() => {
    let tempList = imgs.reduce((acc, obj) => {
      const tempBanner = {
        ...obj,
        image: obj.image.replace("xxx", device ? "mobile" : "desktop"),
      };
      acc.push(tempBanner);
      return acc;
    }, []);

    setLiveBanners([...tempList]);
  }, [device]);

  useEffect(() => {
    if (swiper) {
      if (showTycModal) swiper.autoplay.pause();
    }
  }, [showTycModal]);

  function getDisclamerData(bannerName) {
    switch (bannerName) {
      case "MX-Casino5000":
        return "Juego Responsable. Permiso no. DGG/SP/442/97, DGJS/234/2019 y DGJS/2475/2024 ";
        break;
      case "MX-Multi10005000":
        return "Juego Responsable. Permiso no. DGG/SP/442/97, DGJS/234/2019, DGJS/2475/2024 y DGJS/0757/2025.";
        break;
      case "in-out":
        return "Juego Responsable. Permiso no. DGJS/0529/2025";
        break;
      default:
      // code block
    }
  }
  function dateInBetween(banner) {
    return (
      new Date() >= new Date(banner.startDate) &&
      new Date() <= new Date(banner.endDate)
    );
  }
  function BannerFilter(banner) {
    if (!banner.scheduled) return banner;
    else {
      if (dateInBetween(banner)) return banner;
    }
  }

  const imageHandler = (item) => {
    const x = isLiveOnTv();
    return item.hasTimer
      ? x
        ? item.alterImage.replace("desktop", device ? "mobile" : "desktop")
        : item.image
      : item.image;
  };

  const modalGenerator = () => {
    return (
      <>
        <Modal
          centered
          show={showTycModal}
          onHide={() => setShowTycModal(false)}
          contentClassName="terms-tyc"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <div className="text-center">
                <h5>Términos y condiciones</h5>
                <h5>{tycObject.title}</h5>
              </div>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>{tycGenerator()}</Modal.Body>
          <Modal.Footer>
            <Button
              onClick={() => setShowTycModal(false)}
              className="accept-btn"
            >
              Aceptar
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  };

  const tycGenerator = () => {
    return (
      <iframe
        width="100%"
        height="400px"
        title="tyc"
        src={`https://www.codere.mx/library/tyc/tyc-${tycObject.refTo}.html`}
      />
    );
  };

  return (
    // <div>
    <div style={{ minHeight: `${device ? 62 : 73}vh` }}>
      {liveBanners.length > 0 && (
        <>
          {/* {showTimer && <Timer device={device} />} */}
          <Swiper
            onSlideChange={(swiper) => indexHandler(swiper)}
            modules={[Pagination, EffectFade, Autoplay, Lazy]}
            pagination={{ clickable: true }}
            effect="fade"
            // lazy={{ loadPrevNext: true, loadPrevNextAmount: 1 }}
            autoplay={{ delay: 3250, disableOnInteraction: true }}
            spaceBetween={0}
            slidesPerView={1}
            loop={true}
            // onImagesReady={onReadyHandler}
          >
            {liveBanners.map((item, index) => (
              <SwiperSlide key={index}>
                <a href={item.ctaLink}>
                  <img
                    width={device ? "300" : "400"}
                    height={device ? "410" : "140"}
                    src={`${SPEEDSIZE_PREFIX}/${imageHandler(item, index)}`}
                    alt={item.banner_name}
                  />
                </a>
              </SwiperSlide>
            ))}
          </Swiper>

          {!device ? (
            <div id="des-reg">
              <Button className="central-regis" href={ctaLink} rel="nofollow">
                {ctaText.replace("gist", "gíst")}
                <Arrowrightw />
              </Button>
              {tycObject.type !== "No Tyc" && (
                <span
                  className="tyc"
                  onClick={() => {
                    tycObject.type === "Pop-Up"
                      ? setShowTycModal(true)
                      : window.open(tycObject.refTo, "_self");
                  }}
                >
                  Términos y condiciones
                </span>
              )}
              <div className="disclamer">{disclaimer}</div>
            </div>
          ) : (
            <div className="ReactSwipeButton mobile_regis">
              <SlideButton regis={ctaLink} ctaText={ctaText} />
              {tycObject.type !== "No Tyc" && (
                <div className="mob-tyc">
                  <span
                    className="tyc"
                    onClick={() => {
                      tycObject.type === "Pop-Up"
                        ? setShowTycModal(true)
                        : window.open(tycObject.refTo, "_self");
                    }}
                  >
                    Términos y condiciones
                  </span>
                </div>
              )}
              <div className="disclamer">{disclaimer}</div>
            </div>
          )}

          {modalGenerator()}
        </>
      )}
    </div>
  );
}
export default MySwiper;
